import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushEvent } from "@/lib/analytics";

/**
 * Fires GTM virtual_pageview events on SPA route changes and delegates
 * tel:/mailto:/PDF clicks into dataLayer events. Must be rendered inside
 * <BrowserRouter>.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    pushEvent({
      event: "virtual_pageview",
      page_path: location.pathname + location.search,
      page_title: typeof document !== "undefined" ? document.title : "",
    });
  }, [location]);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const handler = (e: MouseEvent) => {
      const a = (e.target as HTMLElement | null)?.closest?.("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";

      if (href.startsWith("tel:")) {
        pushEvent({ event: "phone_click", phone_number: href.replace("tel:", "") });
      } else if (href.startsWith("mailto:")) {
        pushEvent({
          event: "email_click",
          email_address: href.replace("mailto:", "").split("?")[0],
        });
      } else if (/\.pdf($|\?)/i.test(href)) {
        pushEvent({
          event: "brochure_download",
          file_url: href,
          file_name: href.split("/").pop()?.split("?")[0] || "unknown.pdf",
        });
      }
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  return null;
}
